import React, { useState, useCallback, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { CREATE_LINKED_ATTACHMENT } from '../queries';
import { ContentContainer } from '../../../elements';
import { View } from 'react-native';
import {
  LinkedAttachmentContainer,
  LinkedAttachmentInnerContainer,
  LinkedAttachmentTitle
} from '../elements';
import { ButtonGroup, Button } from '../../../elements/buttons';
import { useForm } from 'react-hook-form';
import Input from '../../../elements/inputs';

const NewLinkedAttachment = (props) => {
  const {
    setShowModal,
    setValue,
    resourceType,
    resourceId,
  } = props;
  const [submitting, setSubmitting] = useState(false);
  const [linkedFiles, setLinkedFiles] = useState();
  const [saveLinkedAttachment] = useMutation(CREATE_LINKED_ATTACHMENT,
    {
      onCompleted(response) {
        setShowModal(false);
        // updateAttachments(
        //   'add',
        //   response.uploadAttachment.attachment
        // )
      }
    }
  );

  const onSubmit = useCallback(input => {
    setSubmitting(true);
  });

  const {
    control, register, handleSubmit, watch, formState: { errors }
  } = useForm({
    defaultValues: {
      name: '',
      url: ''
    }
  });

  const watchName = watch('name');
  const watchUrl = watch('url');

  useEffect(() => {
    if(watchUrl.length) {
      setValue('linkedAttachment',
      {
        name: watchName || 'Title File',
        url: watchUrl,
        resourceId: resourceId,
        resourceType: resourceType,
      }
    )}
  }, [watchName, watchUrl]);

  return (
    <LinkedAttachmentContainer>
      <LinkedAttachmentTitle>Linked Attachment:</LinkedAttachmentTitle>
      <LinkedAttachmentInnerContainer>
        <Input.Text
          label="Name:"
          name="name"
          placeholder='Title File'
          control={control}
          errors={errors}
        />
        <Input.Text
          label="URL:"
          name="url"
          control={control}
          errors={errors}
        />
        {/* <ButtonContainer>
          <ButtonGroup>
            <Button
              label={`Upload ${attachmentType}`}
              onPress={() => handleSubmit()}
            />
          </ButtonGroup>
        </ButtonContainer> */}
      </LinkedAttachmentInnerContainer>
    </LinkedAttachmentContainer>
  )
}

export default NewLinkedAttachment;
